import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=08133b2c&scoped=true&lang=pug&"
import script from "./Maintenance.vue?vue&type=script&lang=js&"
export * from "./Maintenance.vue?vue&type=script&lang=js&"
import style0 from "./Maintenance.vue?vue&type=style&index=0&id=08133b2c&lang=scss&scoped=true&"
import style1 from "./Maintenance.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08133b2c",
  null
  
)

export default component.exports